import { graphql } from "react-relay";

export const eventSuggestedTimesWarningFragments = {
  org: graphql`
    fragment EventSuggestedTimesWarning_org on Org {
      workingGroups(first: 1000000) {
        edges {
          node {
            rooms {
              id
              roomId
              orgId
              name
              estimatedCapacity
            }
          }
        }
      }
    }
  `,
};
